module.exports = __webpack_public_path__ + "img/add_black.79564d07.svg";